export default "__VITE_ASSET__CQeh_Inm__"